<template>
  <div>
    <VehiclesHeader title="Nuevo Vehículo"/>
    <hr>
    <VehiclesForm :vehicle="vehicle" @onCreate="onCreate"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import VehiclesHeader from '../VehiclesHeader'
import VehiclesForm from '../VehiclesForm'

export default {
  name: 'VehicleNew',
  components: { VehiclesHeader, VehiclesForm },
  data () {
    return {
      vehicle: {
        brand: '',
        model: '',
        carPlate: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleVehicleBtnLoading'
    ]),
    ...mapActions([
      'createVehicle',
      'setAlertData',
      'isVehicleBtnLoading'
    ]),
    onCreate (data) {
      this.toggleVehicleBtnLoading(true)
      data.createdAt = new Date().getTime()
      this.createVehicle(data)
        .then((res) => {
          this.toggleVehicleBtnLoading(false)
          this.$router.push({ name: 'Vehicles' })
          this.setAlertData({
            visible: true,
            msg: 'Vehículo creado ;)',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleVehicleBtnLoading(false)
          console.log('[onCreateVehicle]')
          console.log(err.toString())
        })
    }
  }
}
</script>
